/* eslint-disable */

/**
 * Use this url to update all content below this comment.
 *
 * https://cdn.polyfill.io/v2/polyfill.js?features=IntersectionObserver|gated,Array.from|gated,Array.prototype.includes|gated,Array.prototype.find|gated,Array.prototype.findIndex|gated,Object.assign|gated,Object.entries|gated,Object.values|gated,Number.isInteger|gated,String.prototype.includes|gated,String.prototype.startsWith|gated,Set,promise|gated,fetch|gated,CustomEvent|gated&ua=Mozilla/5.0%20(compatible;%20MSIE%2010.0;%20Windows%20NT%206.1;%20Trident/6.0)
 */

/* Polyfill service v3.25.1
 * For detailed credits and licence information see https://github.com/financial-times/polyfill-service.
 *
 * UA detected: ie/10.0.0
 * Features requested: Array.from,Array.prototype.findIndex,Array.prototype.find,Array.prototype.includes,CustomEvent,IntersectionObserver,Number.isInteger,Object.assign,Object.entries,Object.values,Set,String.prototype.includes,String.prototype.startsWith,fetch,promise
 *
 * - Object.keys, License: MIT (required by "Object.assign", "Object.entries", "Object.values", "Symbol", "Set")
 * - Object.assign, License: CC0 (required by "_Iterator", "_ArrayIterator", "Array.from")
 * - Symbol, License: MIT (required by "Set", "Symbol.iterator", "Symbol.species", "_Iterator", "_ArrayIterator", "Array.from", "Symbol.toStringTag")
 * - Symbol.iterator, License: MIT (required by "Set", "_Iterator", "_ArrayIterator", "Array.from")
 * - Symbol.toStringTag, License: MIT (required by "_Iterator", "_ArrayIterator", "Array.from")
 * - _Iterator, License: MIT (required by "_ArrayIterator", "Array.from")
 * - Object.setPrototypeOf, License: MIT (required by "_ArrayIterator", "Array.from")
 * - String.prototype.includes, License: CC0 (required by "String.prototype.contains", "_ArrayIterator", "Array.from")
 * - String.prototype.contains, License: CC0 (required by "_ArrayIterator", "Array.from")
 * - _ArrayIterator, License: MIT (required by "Array.from")
 * - Number.isFinite, License: MIT (required by "Array.from")
 * - Number.isNaN, License: MIT (required by "Array.from", "Set")
 * - Array.from, License: CC0
 * - Array.prototype.findIndex, License: CC0
 * - Array.prototype.find, License: CC0
 * - Array.prototype.includes, License: CC0
 * - Event, License: CC0 (required by "CustomEvent", "IntersectionObserver", "XMLHttpRequest", "fetch")
 * - CustomEvent, License: CC0
 * - IntersectionObserver, License: CC0
 * - Number.isInteger, License: MIT
 * - Object.entries, License: CC0
 * - Object.values, License: CC0
 * - Symbol.species, License: MIT (required by "Set")
 * - Set, License: CC0
 * - String.prototype.startsWith, License: CC0
 * - Promise, License: MIT (required by "fetch")
 * - fetch, License: MIT */

(function(undefined) {
    if (!('keys' in Object && (function () {
        // Safari 5.0 bug where Object.keys doesn't work with arguments
        return (Object.keys(arguments)).length === 2;
    }(1, 2)) && (function () {
        try {
            // In ES6 Object.keys works on all object except `null` and `undefined`.
            Object.keys('');
            return true;
        } catch (e) {
            return false;
        }
    }()))) {

// Object.keys
        Object.keys = (function() {
            'use strict';

            // modified from https://github.com/es-shims/object-keys

            var has = Object.prototype.hasOwnProperty;
            var toStr = Object.prototype.toString;
            var isEnumerable = Object.prototype.propertyIsEnumerable;
            var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
            var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
            var dontEnums = [
                'toString',
                'toLocaleString',
                'valueOf',
                'hasOwnProperty',
                'isPrototypeOf',
                'propertyIsEnumerable',
                'constructor'
            ];
            var equalsConstructorPrototype = function (o) {
                var ctor = o.constructor;
                return ctor && ctor.prototype === o;
            };
            var excludedKeys = {
                $console: true,
                $external: true,
                $frame: true,
                $frameElement: true,
                $frames: true,
                $innerHeight: true,
                $innerWidth: true,
                $outerHeight: true,
                $outerWidth: true,
                $pageXOffset: true,
                $pageYOffset: true,
                $parent: true,
                $scrollLeft: true,
                $scrollTop: true,
                $scrollX: true,
                $scrollY: true,
                $self: true,
                $webkitIndexedDB: true,
                $webkitStorageInfo: true,
                $window: true
            };
            var hasAutomationEqualityBug = (function () {
                /* global window */
                if (typeof window === 'undefined') { return false; }
                for (var k in window) {
                    try {
                        if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
                            try {
                                equalsConstructorPrototype(window[k]);
                            } catch (e) {
                                return true;
                            }
                        }
                    } catch (e) {
                        return true;
                    }
                }
                return false;
            }());
            var equalsConstructorPrototypeIfNotBuggy = function (o) {
                /* global window */
                if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
                    return equalsConstructorPrototype(o);
                }
                try {
                    return equalsConstructorPrototype(o);
                } catch (e) {
                    return false;
                }
            };

            function isArgumentsObject(value) {
                var str = toStr.call(value);
                var isArgs = str === '[object Arguments]';
                if (!isArgs) {
                    isArgs = str !== '[object Array]' &&
                        value !== null &&
                        typeof value === 'object' &&
                        typeof value.length === 'number' &&
                        value.length >= 0 &&
                        toStr.call(value.callee) === '[object Function]';
                }
                return isArgs;
            };

            return function keys(object) {
                var isFunction = toStr.call(object) === '[object Function]';
                var isArguments = isArgumentsObject(object);
                var isString = toStr.call(object) === '[object String]';
                var theKeys = [];

                if (object === undefined || object === null) {
                    throw new TypeError('Cannot convert undefined or null to object');
                }

                var skipProto = hasProtoEnumBug && isFunction;
                if (isString && object.length > 0 && !has.call(object, 0)) {
                    for (var i = 0; i < object.length; ++i) {
                        theKeys.push(String(i));
                    }
                }

                if (isArguments && object.length > 0) {
                    for (var j = 0; j < object.length; ++j) {
                        theKeys.push(String(j));
                    }
                } else {
                    for (var name in object) {
                        if (!(skipProto && name === 'prototype') && has.call(object, name)) {
                            theKeys.push(String(name));
                        }
                    }
                }

                if (hasDontEnumBug) {
                    var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

                    for (var k = 0; k < dontEnums.length; ++k) {
                        if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
                            theKeys.push(dontEnums[k]);
                        }
                    }
                }
                return theKeys;
            };
        }());

    }

    if (!('assign' in Object)) {

// Object.assign
        (function() {

            // 7.1.13 ToObject ( argument )
            function toObject(argument) {
                if (argument === null || argument === undefined) {
                    throw new TypeError('Cannot call method on ' + argument);
                }
                return Object(argument);
            }

            Object.defineProperty(Object, 'assign', {
                enumerable: false,
                configurable: true,
                writable: true,
                // 19.1.2.1 Object.assign ( target, ...sources )
                value: function assign(target, source) { // eslint-disable-line no-unused-vars

                    // 1. Let to be ? ToObject(target).
                    var to = toObject(target);

                    // 2. If only one argument was passed, return to.
                    if (arguments.length === 1) {
                        return to;
                    }

                    // 3. Let sources be the List of argument values starting with the second argument
                    var sources = Array.prototype.slice.call(arguments, 1);

                    // 4. For each element nextSource of sources, in ascending index order, do
                    var index1;
                    var index2;
                    var keys;
                    var key;
                    var from;
                    for (index1 = 0; index1 < sources.length; index1++) {
                        var nextSource = sources[index1];
                        // 4a. If nextSource is undefined or null, let keys be a new empty List.
                        if (nextSource === undefined || nextSource === null) {
                            keys = [];
                            // 4b. Else,
                        } else {
                            // 4bi. Let from be ! ToObject(nextSource).
                            from = toObject(nextSource);
                            // 4bii. Let keys be ? from.[[OwnPropertyKeys]]().
                            /*
                                This step in our polyfill is not complying with the specification.
                                [[OwnPropertyKeys]] is meant to return ALL keys, including non-enumerable and symbols.
                                TODO: When we have Reflect.ownKeys, use that instead as it is the userland equivalent of [[OwnPropertyKeys]].
                            */
                            keys = Object.keys(from);
                        }

                        // 4c. For each element nextKey of keys in List order, do
                        for (index2 = 0; index2 < keys.length; index2++) {
                            var nextKey = keys[index2];
                            // 4ci. Let desc be ? from.[[GetOwnProperty]](nextKey).
                            var desc = Object.getOwnPropertyDescriptor(from, nextKey);
                            // 4cii. If desc is not undefined and desc.[[Enumerable]] is true, then
                            if (desc !== undefined && desc.enumerable) {
                                // 4cii1. Let propValue be ? Get(from, nextKey).
                                var propValue = from[nextKey];
                                // 4cii2. Perform ? Set(to, nextKey, propValue, true).
                                to[nextKey] = propValue;
                            }
                        }
                    }
                    // 5. Return to.
                    return to;
                }
            });
        }());

    }

    if (!('Symbol' in this)) {

// Symbol
// A modification of https://github.com/WebReflection/get-own-property-symbols
// (C) Andrea Giammarchi - MIT Licensed

        (function (Object, GOPS, global) {

            var setDescriptor;
            var id = 0;
            var random = '' + Math.random();
            var prefix = '__\x01symbol:';
            var prefixLength = prefix.length;
            var internalSymbol = '__\x01symbol@@' + random;
            var DP = 'defineProperty';
            var DPies = 'defineProperties';
            var GOPN = 'getOwnPropertyNames';
            var GOPD = 'getOwnPropertyDescriptor';
            var PIE = 'propertyIsEnumerable';
            var ObjectProto = Object.prototype;
            var hOP = ObjectProto.hasOwnProperty;
            var pIE = ObjectProto[PIE];
            var toString = ObjectProto.toString;
            var concat = Array.prototype.concat;
            var cachedWindowNames = typeof window === 'object' ? Object.getOwnPropertyNames(window) : [];
            var nGOPN = Object[GOPN];
            var gOPN = function getOwnPropertyNames (obj) {
                if (toString.call(obj) === '[object Window]') {
                    try {
                        return nGOPN(obj);
                    } catch (e) {
                        // IE bug where layout engine calls userland gOPN for cross-domain `window` objects
                        return concat.call([], cachedWindowNames);
                    }
                }
                return nGOPN(obj);
            };
            var gOPD = Object[GOPD];
            var create = Object.create;
            var keys = Object.keys;
            var freeze = Object.freeze || Object;
            var defineProperty = Object[DP];
            var $defineProperties = Object[DPies];
            var descriptor = gOPD(Object, GOPN);
            var addInternalIfNeeded = function (o, uid, enumerable) {
                if (!hOP.call(o, internalSymbol)) {
                    try {
                        defineProperty(o, internalSymbol, {
                            enumerable: false,
                            configurable: false,
                            writable: false,
                            value: {}
                        });
                    } catch (e) {
                        o[internalSymbol] = {};
                    }
                }
                o[internalSymbol]['@@' + uid] = enumerable;
            };
            var createWithSymbols = function (proto, descriptors) {
                var self = create(proto);
                gOPN(descriptors).forEach(function (key) {
                    if (propertyIsEnumerable.call(descriptors, key)) {
                        $defineProperty(self, key, descriptors[key]);
                    }
                });
                return self;
            };
            var copyAsNonEnumerable = function (descriptor) {
                var newDescriptor = create(descriptor);
                newDescriptor.enumerable = false;
                return newDescriptor;
            };
            var get = function get(){};
            var onlyNonSymbols = function (name) {
                return name != internalSymbol &&
                    !hOP.call(source, name);
            };
            var onlySymbols = function (name) {
                return name != internalSymbol &&
                    hOP.call(source, name);
            };
            var propertyIsEnumerable = function propertyIsEnumerable(key) {
                var uid = '' + key;
                return onlySymbols(uid) ? (
                    hOP.call(this, uid) &&
                    this[internalSymbol]['@@' + uid]
                ) : pIE.call(this, key);
            };
            var setAndGetSymbol = function (uid) {
                var descriptor = {
                    enumerable: false,
                    configurable: true,
                    get: get,
                    set: function (value) {
                        setDescriptor(this, uid, {
                            enumerable: false,
                            configurable: true,
                            writable: true,
                            value: value
                        });
                        addInternalIfNeeded(this, uid, true);
                    }
                };
                try {
                    defineProperty(ObjectProto, uid, descriptor);
                } catch (e) {
                    ObjectProto[uid] = descriptor.value;
                }
                return freeze(source[uid] = defineProperty(
                    Object(uid),
                    'constructor',
                    sourceConstructor
                ));
            };
            var Symbol = function Symbol(description) {
                if (this instanceof Symbol) {
                    throw new TypeError('Symbol is not a constructor');
                }
                return setAndGetSymbol(
                    prefix.concat(description || '', random, ++id)
                );
            };
            var source = create(null);
            var sourceConstructor = {value: Symbol};
            var sourceMap = function (uid) {
                return source[uid];
            };
            var $defineProperty = function defineProp(o, key, descriptor) {
                var uid = '' + key;
                if (onlySymbols(uid)) {
                    setDescriptor(o, uid, descriptor.enumerable ?
                        copyAsNonEnumerable(descriptor) : descriptor);
                    addInternalIfNeeded(o, uid, !!descriptor.enumerable);
                } else {
                    defineProperty(o, key, descriptor);
                }
                return o;
            };

            var onlyInternalSymbols = function (obj) {
                return function (name) {
                    return hOP.call(obj, internalSymbol) && hOP.call(obj[internalSymbol], '@@' + name);
                };
            };
            var $getOwnPropertySymbols = function getOwnPropertySymbols(o) {
                    return gOPN(o).filter(o === ObjectProto ? onlyInternalSymbols(o) : onlySymbols).map(sourceMap);
                }
            ;

            descriptor.value = $defineProperty;
            defineProperty(Object, DP, descriptor);

            descriptor.value = $getOwnPropertySymbols;
            defineProperty(Object, GOPS, descriptor);

            descriptor.value = function getOwnPropertyNames(o) {
                return gOPN(o).filter(onlyNonSymbols);
            };
            defineProperty(Object, GOPN, descriptor);

            descriptor.value = function defineProperties(o, descriptors) {
                var symbols = $getOwnPropertySymbols(descriptors);
                if (symbols.length) {
                    keys(descriptors).concat(symbols).forEach(function (uid) {
                        if (propertyIsEnumerable.call(descriptors, uid)) {
                            $defineProperty(o, uid, descriptors[uid]);
                        }
                    });
                } else {
                    $defineProperties(o, descriptors);
                }
                return o;
            };
            defineProperty(Object, DPies, descriptor);

            descriptor.value = propertyIsEnumerable;
            defineProperty(ObjectProto, PIE, descriptor);

            descriptor.value = Symbol;
            defineProperty(global, 'Symbol', descriptor);

            // defining `Symbol.for(key)`
            descriptor.value = function (key) {
                var uid = prefix.concat(prefix, key, random);
                return uid in ObjectProto ? source[uid] : setAndGetSymbol(uid);
            };
            defineProperty(Symbol, 'for', descriptor);

            // defining `Symbol.keyFor(symbol)`
            descriptor.value = function (symbol) {
                if (onlyNonSymbols(symbol))
                    throw new TypeError(symbol + ' is not a symbol');
                return hOP.call(source, symbol) ?
                    symbol.slice(prefixLength * 2, -random.length) :
                    void 0
                    ;
            };
            defineProperty(Symbol, 'keyFor', descriptor);

            descriptor.value = function getOwnPropertyDescriptor(o, key) {
                var descriptor = gOPD(o, key);
                if (descriptor && onlySymbols(key)) {
                    descriptor.enumerable = propertyIsEnumerable.call(o, key);
                }
                return descriptor;
            };
            defineProperty(Object, GOPD, descriptor);

            descriptor.value = function (proto, descriptors) {
                return arguments.length === 1 || typeof descriptors === "undefined" ?
                    create(proto) :
                    createWithSymbols(proto, descriptors);
            };
            defineProperty(Object, 'create', descriptor);

            descriptor.value = function () {
                var str = toString.call(this);
                return (str === '[object String]' && onlySymbols(this)) ? '[object Symbol]' : str;
            };
            defineProperty(ObjectProto, 'toString', descriptor);


            setDescriptor = function (o, key, descriptor) {
                var protoDescriptor = gOPD(ObjectProto, key);
                delete ObjectProto[key];
                defineProperty(o, key, descriptor);
                if (o !== ObjectProto) {
                    if (!protoDescriptor) {return;} // This is a fiverr modification
                    defineProperty(ObjectProto, key, protoDescriptor);
                }
            };

        }(Object, 'getOwnPropertySymbols', this));

    }

    if (!('Symbol' in this && 'iterator' in this.Symbol)) {

// Symbol.iterator
        Object.defineProperty(Symbol, 'iterator', {value: Symbol('iterator')});

    }

    if (!('Symbol' in this && 'toStringTag' in this.Symbol)) {

// Symbol.toStringTag
        Object.defineProperty(Symbol, 'toStringTag', {
            value: Symbol('toStringTag')
        });

    }


// _Iterator
// A modification of https://github.com/medikoo/es6-iterator
// Copyright (C) 2013-2015 Mariusz Nowak (www.medikoo.com)

    var Iterator = (function () { // eslint-disable-line no-unused-vars
        var clear = function () {
            this.length = 0;
            return this;
        };
        var callable = function (fn) {
            if (typeof fn !== 'function') throw new TypeError(fn + " is not a function");
            return fn;
        };

        var Iterator = function (list, context) {
            if (!(this instanceof Iterator)) {
                return new Iterator(list, context);
            }
            Object.defineProperties(this, {
                __list__: {
                    writable: true,
                    value: list
                },
                __context__: {
                    writable: true,
                    value: context
                },
                __nextIndex__: {
                    writable: true,
                    value: 0
                }
            });
            if (!context) return;
            callable(context.on);
            context.on('_add', this._onAdd.bind(this));
            context.on('_delete', this._onDelete.bind(this));
            context.on('_clear', this._onClear.bind(this));
        };

        Object.defineProperties(Iterator.prototype, Object.assign({
            constructor: {
                value: Iterator,
                configurable: true,
                enumerable: false,
                writable: true
            },
            _next: {
                value: function () {
                    var i;
                    if (!this.__list__) return;
                    if (this.__redo__) {
                        i = this.__redo__.shift();
                        if (i !== undefined) return i;
                    }
                    if (this.__nextIndex__ < this.__list__.length) return this.__nextIndex__++;
                    this._unBind();
                },
                configurable: true,
                enumerable: false,
                writable: true
            },
            next: {
                value: function () {
                    return this._createResult(this._next());
                },
                configurable: true,
                enumerable: false,
                writable: true
            },
            _createResult: {
                value: function (i) {
                    if (i === undefined) return {
                        done: true,
                        value: undefined
                    };
                    return {
                        done: false,
                        value: this._resolve(i)
                    };
                },
                configurable: true,
                enumerable: false,
                writable: true
            },
            _resolve: {
                value: function (i) {
                    return this.__list__[i];
                },
                configurable: true,
                enumerable: false,
                writable: true
            },
            _unBind: {
                value: function () {
                    this.__list__ = null;
                    delete this.__redo__;
                    if (!this.__context__) return;
                    this.__context__.off('_add', this._onAdd.bind(this));
                    this.__context__.off('_delete', this._onDelete.bind(this));
                    this.__context__.off('_clear', this._onClear.bind(this));
                    this.__context__ = null;
                },
                configurable: true,
                enumerable: false,
                writable: true
            },
            toString: {
                value: function () {
                    return '[object Iterator]';
                },
                configurable: true,
                enumerable: false,
                writable: true
            }
        }, {
            _onAdd: {
                value: function (index) {
                    if (index >= this.__nextIndex__) return;
                    ++this.__nextIndex__;
                    if (!this.__redo__) {
                        Object.defineProperty(this, '__redo__', {
                            value: [index],
                            configurable: true,
                            enumerable: false,
                            writable: false
                        });
                        return;
                    }
                    this.__redo__.forEach(function (redo, i) {
                        if (redo >= index) this.__redo__[i] = ++redo;
                    }, this);
                    this.__redo__.push(index);
                },
                configurable: true,
                enumerable: false,
                writable: true
            },
            _onDelete: {
                value: function (index) {
                    var i;
                    if (index >= this.__nextIndex__) return;
                    --this.__nextIndex__;
                    if (!this.__redo__) return;
                    i = this.__redo__.indexOf(index);
                    if (i !== -1) this.__redo__.splice(i, 1);
                    this.__redo__.forEach(function (redo, i) {
                        if (redo > index) this.__redo__[i] = --redo;
                    }, this);
                },
                configurable: true,
                enumerable: false,
                writable: true
            },
            _onClear: {
                value: function () {
                    if (this.__redo__) clear.call(this.__redo__);
                    this.__nextIndex__ = 0;
                },
                configurable: true,
                enumerable: false,
                writable: true
            }
        }));

        Object.defineProperty(Iterator.prototype, Symbol.iterator, {
            value: function () {
                return this;
            },
            configurable: true,
            enumerable: false,
            writable: true
        });
        Object.defineProperty(Iterator.prototype, Symbol.toStringTag, {
            value: 'Iterator',
            configurable: false,
            enumerable: false,
            writable: true
        });

        return Iterator;
    }());

// Object.setPrototypeOf
// ES6-shim 0.16.0 (c) 2013-2014 Paul Miller (http://paulmillr.com)
// ES6-shim may be freely distributed under the MIT license.
// For more details and documentation:
// https://github.com/paulmillr/es6-shim/

    // NOTE:  This versions needs object ownership
    //        because every promoted object needs to be reassigned
    //        otherwise uncompatible browsers cannot work as expected
    //
    // NOTE:  This might need es5-shim or polyfills upfront
    //        because it's based on ES5 API.
    //        (probably just an IE <= 8 problem)
    //
    // NOTE:  nodejs is fine in version 0.8, 0.10, and future versions.
    (function () {
        if (Object.setPrototypeOf) { return; }

        /*jshint proto: true */
        // @author    Andrea Giammarchi - @WebReflection

        var getOwnPropertyNames = Object.getOwnPropertyNames;
        var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
        var create = Object.create;
        var defineProperty = Object.defineProperty;
        var getPrototypeOf = Object.getPrototypeOf;
        var objProto = Object.prototype;

        var copyDescriptors = function (target, source) {
            // define into target descriptors from source
            getOwnPropertyNames(source).forEach(function (key) {
                defineProperty(
                    target,
                    key,
                    getOwnPropertyDescriptor(source, key)
                );
            });
            return target;
        };
        // used as fallback when no promotion is possible
        var createAndCopy = function (origin, proto) {
            return copyDescriptors(create(proto), origin);
        };
        var set, setPrototypeOf;
        try {
            // this might fail for various reasons
            // ignore if Chrome cought it at runtime
            set = getOwnPropertyDescriptor(objProto, '__proto__').set;
            set.call({}, null);
            // setter not poisoned, it can promote
            // Firefox, Chrome
            setPrototypeOf = function (origin, proto) {
                set.call(origin, proto);
                return origin;
            };
        } catch (e) {
            // do one or more feature detections
            set = { __proto__: null };
            // if proto does not work, needs to fallback
            // some Opera, Rhino, ducktape
            if (set instanceof Object) {
                setPrototypeOf = createAndCopy;
            } else {
                // verify if null objects are buggy
                /* eslint-disable no-proto */
                set.__proto__ = objProto;
                /* eslint-enable no-proto */
                // if null objects are buggy
                // nodejs 0.8 to 0.10
                if (set instanceof Object) {
                    setPrototypeOf = function (origin, proto) {
                        // use such bug to promote
                        /* eslint-disable no-proto */
                        origin.__proto__ = proto;
                        /* eslint-enable no-proto */
                        return origin;
                    };
                } else {
                    // try to use proto or fallback
                    // Safari, old Firefox, many others
                    setPrototypeOf = function (origin, proto) {
                        // if proto is not null
                        if (getPrototypeOf(origin)) {
                            // use __proto__ to promote
                            /* eslint-disable no-proto */
                            origin.__proto__ = proto;
                            /* eslint-enable no-proto */
                            return origin;
                        } else {
                            // otherwise unable to promote: fallback
                            return createAndCopy(origin, proto);
                        }
                    };
                }
            }
        }
        Object.setPrototypeOf = setPrototypeOf;
    }());
    if (!('includes' in String.prototype)) {

// String.prototype.includes
        String.prototype.includes = function (string, index) {
            if (typeof string === 'object' && string instanceof RegExp) throw new TypeError("First argument to String.prototype.includes must not be a regular expression");
            return this.indexOf(string, index) !== -1;
        };

    }

    if (!('contains' in String.prototype)) {

// String.prototype.contains
        String.prototype.contains = String.prototype.includes;

    }


// _ArrayIterator
// A modification of https://github.com/medikoo/es6-iterator
// Copyright (C) 2013-2015 Mariusz Nowak (www.medikoo.com)

    var ArrayIterator = (function() { // eslint-disable-line no-unused-vars

        var ArrayIterator = function(arr, kind) {
            if (!(this instanceof ArrayIterator)) return new ArrayIterator(arr, kind);
            Iterator.call(this, arr);
            if (!kind) kind = 'value';
            else if (String.prototype.contains.call(kind, 'key+value')) kind = 'key+value';
            else if (String.prototype.contains.call(kind, 'key')) kind = 'key';
            else kind = 'value';
            Object.defineProperty(this, '__kind__', {
                value: kind,
                configurable: false,
                enumerable: false,
                writable: false
            });
        };
        if (Object.setPrototypeOf) Object.setPrototypeOf(ArrayIterator, Iterator.prototype);

        ArrayIterator.prototype = Object.create(Iterator.prototype, {
            constructor: {
                value: ArrayIterator,
                configurable: true,
                enumerable: false,
                writable: true
            },
            _resolve: {
                value: function(i) {
                    if (this.__kind__ === 'value') return this.__list__[i];
                    if (this.__kind__ === 'key+value') return [i, this.__list__[i]];
                    return i;
                },
                configurable: true,
                enumerable: false,
                writable: true
            },
            toString: {
                value: function() {
                    return '[object Array Iterator]';
                },
                configurable: true,
                enumerable: false,
                writable: true
            }
        });

        return ArrayIterator;
    }());
    if (!('isFinite' in Number)) {

// Number.isFinite
        Number.isFinite = Number.isFinite || function(value) {
            return typeof value === "number" && isFinite(value);
        };

    }

    if (!('isNaN' in Number)) {

// Number.isNaN
        Number.isNaN = Number.isNaN || function(value) {
            return typeof value === "number" && isNaN(value);
        };

    }

    if (!('from' in Array && (function () {
        try {
            Array.from({ length: -Infinity });

            return true;
        } catch (e) {
            return false;
        }
    }()))) {

// Array.from
// Wrapped in IIFE to prevent leaking to global scope.
        (function () {
            'use strict';

            function toInteger(value) {
                var number = Number(value);
                return sign(number) * Math.floor(Math.abs(Math.min(Math.max(number || 0, 0), 9007199254740991)));
            }

            var has = Object.prototype.hasOwnProperty;
            var strValue = String.prototype.valueOf;

            var tryStringObject = function tryStringObject(value) {
                try {
                    strValue.call(value);
                    return true;
                } catch (e) {
                    return false;
                }
            };

            function sign(number) {
                return number >= 0 ? 1 : -1;
            }

            var toStr = Object.prototype.toString;
            var strClass = '[object String]';
            var hasSymbols = typeof Symbol === 'function';
            var hasToStringTag = hasSymbols && 'toStringTag' in Symbol;

            function isString(value) {
                if (typeof value === 'string') {
                    return true;
                }
                if (typeof value !== 'object') {
                    return false;
                }
                return hasToStringTag ? tryStringObject(value) : toStr.call(value) === strClass;
            }

            var fnToStr = Function.prototype.toString;

            var constructorRegex = /^\s*class /;
            var isES6ClassFn = function isES6ClassFn(value) {
                try {
                    var fnStr = fnToStr.call(value);
                    var singleStripped = fnStr.replace(/\/\/.*\n/g, '');
                    var multiStripped = singleStripped.replace(/\/\*[.\s\S]*\*\//g, '');
                    var spaceStripped = multiStripped.replace(/\n/mg, ' ').replace(/ {2}/g, ' ');
                    return constructorRegex.test(spaceStripped);
                } catch (e) {
                    return false; // not a function
                }
            };

            var tryFunctionObject = function tryFunctionObject(value) {
                try {
                    if (isES6ClassFn(value)) {
                        return false;
                    }
                    fnToStr.call(value);
                    return true;
                } catch (e) {
                    return false;
                }
            };
            var fnClass = '[object Function]';
            var genClass = '[object GeneratorFunction]';

            function isCallable(value) {
                if (!value) {
                    return false;
                }
                if (typeof value !== 'function' && typeof value !== 'object') {
                    return false;
                }
                if (hasToStringTag) {
                    return tryFunctionObject(value);
                }
                if (isES6ClassFn(value)) {
                    return false;
                }
                var strClass = toStr.call(value);
                return strClass === fnClass || strClass === genClass;
            };
            var isArray = Array.isArray;

            var parseIterable = function (iterator) {
                var done = false;
                var iterableResponse;
                var tempArray = [];

                if (iterator && typeof iterator.next === 'function') {
                    while (!done) {
                        iterableResponse = iterator.next();
                        if (
                            has.call(iterableResponse, 'value') &&
                            has.call(iterableResponse, 'done')
                        ) {
                            if (iterableResponse.done === true) {
                                done = true;
                                break; // eslint-disable-line no-restricted-syntax

                            } else if (iterableResponse.done !== false) {
                                break; // eslint-disable-line no-restricted-syntax
                            }

                            tempArray.push(iterableResponse.value);
                        } else if (iterableResponse.done === true) {
                            done = true;
                            break; // eslint-disable-line no-restricted-syntax
                        } else {
                            break; // eslint-disable-line no-restricted-syntax
                        }
                    }
                }

                return done ? tempArray : false;
            };

            var iteratorSymbol;
            var forOf;
            var hasSet = typeof Set === 'function';
            var hasMap = typeof Map === 'function';

            if (hasSymbols) {
                iteratorSymbol = Symbol.iterator;
            } else {
                var iterate;
                try {
                    iterate = Function('iterable', 'var arr = []; for (var value of iterable) arr.push(value); return arr;'); // eslint-disable-line no-new-func
                } catch (e) {}
                var supportsStrIterator = (function () {
                    try {
                        var supported = false;
                        var obj = { // eslint-disable-line no-unused-vars
                            '@@iterator': function () {
                                return {
                                    'next': function () {
                                        supported = true;
                                        return {
                                            'done': true,
                                            'value': undefined
                                        };
                                    }
                                };
                            }
                        };

                        iterate(obj);
                        return supported;
                    } catch (e) {
                        return false;
                    }
                }());

                if (supportsStrIterator) {
                    iteratorSymbol = '@@iterator';
                } else if (typeof Set === 'function') {
                    var s = new Set();
                    s.add(0);
                    try {
                        if (iterate(s).length === 1) {
                            forOf = iterate;
                        }
                    } catch (e) {}
                }
            }

            var isSet;
            if (hasSet) {
                var setSize = Object.getOwnPropertyDescriptor(Set.prototype, 'size').get;
                isSet = function (set) {
                    try {
                        setSize.call(set);
                        return true;
                    } catch (e) {
                        return false;
                    }
                };
            }

            var isMap;
            if (hasMap) {
                var mapSize = Object.getOwnPropertyDescriptor(Map.prototype, 'size').get;
                isMap = function (m) {
                    try {
                        mapSize.call(m);
                        return true;
                    } catch (e) {
                        return false;
                    }
                };
            }

            var setForEach = hasSet && Set.prototype.forEach;
            var mapForEach = hasMap && Map.prototype.forEach;
            var usingIterator = function (items) {
                var tempArray = [];
                if (has.call(items, iteratorSymbol)) {
                    return items[iteratorSymbol]();
                } else if (setForEach && isSet(items)) {
                    setForEach.call(items, function (val) {
                        tempArray.push(val);
                    });
                    return {
                        next: function () {
                            return tempArray.length === 0
                                ? {
                                    done: true
                                }
                                : {
                                    value: tempArray.splice(0, 1)[0],
                                    done: false
                                };
                        }
                    };
                } else if (mapForEach && isMap(items)) {
                    mapForEach.call(items, function (val, key) {
                        tempArray.push([key, val]);
                    });
                    return {
                        next: function () {
                            return tempArray.length === 0
                                ? {
                                    done: true
                                }
                                : {
                                    value: tempArray.splice(0, 1)[0],
                                    done: false
                                };
                        }
                    };
                }
                return items;
            };

            var strMatch = String.prototype.match;

            var parseIterableLike = function (items) {
                var arr = parseIterable(usingIterator(items));

                if (!arr) {
                    if (isString(items)) {
                        arr = strMatch.call(items, /[\uD800-\uDBFF][\uDC00-\uDFFF]?|[^\uD800-\uDFFF]|./g) || [];
                    } else if (forOf && !isArray(items)) {
                        // Safari 8's native Map or Set can't be iterated except with for..of
                        try {
                            arr = forOf(items);
                        } catch (e) {}
                    }
                }
                return arr || items;
            };

            /*! https://mths.be/array-from v0.2.0 by @mathias */
            Object.defineProperty(Array, 'from', {
                configurable: true,
                value: function from(items) {
                    var C = this;
                    if (items === null || typeof items === 'undefined') {
                        throw new TypeError('`Array.from` requires an array-like object, not `null` or `undefined`');
                    }
                    var mapFn, T;
                    if (typeof arguments[1] !== 'undefined') {
                        mapFn = arguments[1];
                        if (!isCallable(mapFn)) {
                            throw new TypeError('When provided, the second argument to `Array.from` must be a function');
                        }
                        if (arguments.length > 2) {
                            T = arguments[2];
                        }
                    }

                    var arrayLike = Object(parseIterableLike(items));
                    var len = toInteger(arrayLike.length);
                    var A = isCallable(C) ? Object(new C(len)) : new Array(len);
                    var k = 0;
                    var kValue, mappedValue;

                    while (k < len) {
                        kValue = arrayLike[k];
                        if (mapFn) {
                            mappedValue = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.apply(T, [kValue, k]);
                        } else {
                            mappedValue = kValue;
                        }
                        Object.defineProperty(A, k, {
                            'configurable': true,
                            'enumerable': true,
                            'value': mappedValue,
                            'writable': true
                        });
                        k += 1;
                    }
                    A.length = len;
                    return A;
                },
                writable: true
            });
        }());

    }

    if (!('findIndex' in Array.prototype)) {

// Array.prototype.findIndex
        Object.defineProperty(Array.prototype, 'findIndex', {
            configurable: true,
            value: function findIndex(callback) {
                if (this === undefined || this === null) {
                    throw new TypeError(this + ' is not an object');
                }

                if (typeof callback !== 'function') {
                    throw new TypeError(callback + ' is not a function');
                }

                var
                    object = Object(this),
                    scope = arguments[1],
                    arraylike = object instanceof String ? object.split('') : object,
                    length = Math.max(Math.min(arraylike.length, 9007199254740991), 0) || 0,
                    index = -1;

                while (++index < length) {
                    if (index in arraylike) {
                        if (callback.call(scope, arraylike[index], index, object)) {
                            return index;
                        }
                    }
                }

                return -1;
            },
            writable: true
        });

    }

    if (!('find' in Array.prototype)) {

// Array.prototype.find
        Object.defineProperty(Array.prototype, 'find', {
            configurable: true,
            value: function find(callback) {
                if (this === undefined || this === null) {
                    throw new TypeError(this + ' is not an object');
                }

                if (typeof callback !== 'function') {
                    throw new TypeError(callback + ' is not a function');
                }

                var
                    object = Object(this),
                    scope = arguments[1],
                    arraylike = object instanceof String ? object.split('') : object,
                    length = Math.max(Math.min(arraylike.length, 9007199254740991), 0) || 0,
                    index = -1,
                    element;

                while (++index < length) {
                    if (index in arraylike) {
                        element = arraylike[index];

                        if (callback.call(scope, element, index, object)) {
                            return element;
                        }
                    }
                }
            },
            writable: true
        });

    }

    if (!('includes' in Array.prototype)) {

// Array.prototype.includes
        (function () {
            Object.defineProperty(Array.prototype, 'includes', {
                configurable: true,
                value: function includes (searchElement /*, fromIndex*/) {
                    'use strict';
                    var O = Object(this);
                    var len = parseInt(O.length) || 0;
                    if (len === 0) {
                        return false;
                    }
                    var n = parseInt(arguments[1]) || 0;
                    var k;
                    if (n >= 0) {
                        k = n;
                    } else {
                        k = len + n;
                        if (k < 0) {
                            k = 0;
                        }
                    }
                    var currentElement;
                    while (k < len) {
                        currentElement = O[k];
                        if (searchElement === currentElement ||
                            (searchElement !== searchElement && currentElement !== currentElement)) {
                            return true;
                        }
                        k++;
                    }
                    return false;
                },
                writable: true
            });
        }());

    }

    if (!((function(global) {

        if (!('Event' in global)) return false;
        if (typeof global.Event === 'function') return true;

        try {

            // In IE 9-11, the Event object exists but cannot be instantiated
            new Event('click');
            return true;
        } catch(e) {
            return false;
        }
    }(this)))) {

// Event
        (function () {
            var unlistenableWindowEvents = {
                click: 1,
                dblclick: 1,
                keyup: 1,
                keypress: 1,
                keydown: 1,
                mousedown: 1,
                mouseup: 1,
                mousemove: 1,
                mouseover: 1,
                mouseenter: 1,
                mouseleave: 1,
                mouseout: 1,
                storage: 1,
                storagecommit: 1,
                textinput: 1
            };

            // This polyfill depends on availability of `document` so will not run in a worker
            // However, we asssume there are no browsers with worker support that lack proper
            // support for `Event` within the worker
            if (typeof document === 'undefined' || typeof window === 'undefined') return;

            function indexOf(array, element) {
                var
                    index = -1,
                    length = array.length;

                while (++index < length) {
                    if (index in array && array[index] === element) {
                        return index;
                    }
                }

                return -1;
            }

            var existingProto = (window.Event && window.Event.prototype) || null;
            window.Event = Window.prototype.Event = function Event(type, eventInitDict) {
                if (!type) {
                    throw new Error('Not enough arguments');
                }

                var event;
                // Shortcut if browser supports createEvent
                if ('createEvent' in document) {
                    event = document.createEvent('Event');
                    var bubbles = eventInitDict && eventInitDict.bubbles !== undefined ? eventInitDict.bubbles : false;
                    var cancelable = eventInitDict && eventInitDict.cancelable !== undefined ? eventInitDict.cancelable : false;

                    event.initEvent(type, bubbles, cancelable);

                    return event;
                }

                event = document.createEventObject();

                event.type = type;
                event.bubbles = eventInitDict && eventInitDict.bubbles !== undefined ? eventInitDict.bubbles : false;
                event.cancelable = eventInitDict && eventInitDict.cancelable !== undefined ? eventInitDict.cancelable : false;

                return event;
            };
            if (existingProto) {
                Object.defineProperty(window.Event, 'prototype', {
                    configurable: false,
                    enumerable: false,
                    writable: true,
                    value: existingProto
                });
            }

            if (!('createEvent' in document)) {
                window.addEventListener = Window.prototype.addEventListener = Document.prototype.addEventListener = Element.prototype.addEventListener = function addEventListener() {
                    var
                        element = this,
                        type = arguments[0],
                        listener = arguments[1];

                    if (element === window && type in unlistenableWindowEvents) {
                        throw new Error('In IE8 the event: ' + type + ' is not available on the window object. Please see https://github.com/Financial-Times/polyfill-service/issues/317 for more information.');
                    }

                    if (!element._events) {
                        element._events = {};
                    }

                    if (!element._events[type]) {
                        element._events[type] = function (event) {
                            var
                                list = element._events[event.type].list,
                                events = list.slice(),
                                index = -1,
                                length = events.length,
                                eventElement;

                            event.preventDefault = function preventDefault() {
                                if (event.cancelable !== false) {
                                    event.returnValue = false;
                                }
                            };

                            event.stopPropagation = function stopPropagation() {
                                event.cancelBubble = true;
                            };

                            event.stopImmediatePropagation = function stopImmediatePropagation() {
                                event.cancelBubble = true;
                                event.cancelImmediate = true;
                            };

                            event.currentTarget = element;
                            event.relatedTarget = event.fromElement || null;
                            event.target = event.target || event.srcElement || element;
                            event.timeStamp = new Date().getTime();

                            if (event.clientX) {
                                event.pageX = event.clientX + document.documentElement.scrollLeft;
                                event.pageY = event.clientY + document.documentElement.scrollTop;
                            }

                            while (++index < length && !event.cancelImmediate) {
                                if (index in events) {
                                    eventElement = events[index];

                                    if (indexOf(list, eventElement) !== -1 && typeof eventElement === 'function') {
                                        eventElement.call(element, event);
                                    }
                                }
                            }
                        };

                        element._events[type].list = [];

                        if (element.attachEvent) {
                            element.attachEvent('on' + type, element._events[type]);
                        }
                    }

                    element._events[type].list.push(listener);
                };

                window.removeEventListener = Window.prototype.removeEventListener = Document.prototype.removeEventListener = Element.prototype.removeEventListener = function removeEventListener() {
                    var
                        element = this,
                        type = arguments[0],
                        listener = arguments[1],
                        index;

                    if (element._events && element._events[type] && element._events[type].list) {
                        index = indexOf(element._events[type].list, listener);

                        if (index !== -1) {
                            element._events[type].list.splice(index, 1);

                            if (!element._events[type].list.length) {
                                if (element.detachEvent) {
                                    element.detachEvent('on' + type, element._events[type]);
                                }
                                delete element._events[type];
                            }
                        }
                    }
                };

                window.dispatchEvent = Window.prototype.dispatchEvent = Document.prototype.dispatchEvent = Element.prototype.dispatchEvent = function dispatchEvent(event) {
                    if (!arguments.length) {
                        throw new Error('Not enough arguments');
                    }

                    if (!event || typeof event.type !== 'string') {
                        throw new Error('DOM Events Exception 0');
                    }

                    var element = this, type = event.type;

                    try {
                        if (!event.bubbles) {
                            event.cancelBubble = true;

                            var cancelBubbleEvent = function (event) {
                                event.cancelBubble = true;

                                (element || window).detachEvent('on' + type, cancelBubbleEvent);
                            };

                            this.attachEvent('on' + type, cancelBubbleEvent);
                        }

                        this.fireEvent('on' + type, event);
                    } catch (error) {
                        event.target = element;

                        do {
                            event.currentTarget = element;

                            if ('_events' in element && typeof element._events[type] === 'function') {
                                element._events[type].call(element, event);
                            }

                            if (typeof element['on' + type] === 'function') {
                                element['on' + type].call(element, event);
                            }

                            element = element.nodeType === 9 ? element.parentWindow : element.parentNode;
                        } while (element && !event.cancelBubble);
                    }

                    return true;
                };

                // Add the DOMContentLoaded Event
                document.attachEvent('onreadystatechange', function() {
                    if (document.readyState === 'complete') {
                        document.dispatchEvent(new Event('DOMContentLoaded', {
                            bubbles: true
                        }));
                    }
                });
            }
        }());

    }

    if (!('CustomEvent' in this &&

        // In Safari, typeof CustomEvent == 'object' but it otherwise works fine
        (typeof this.CustomEvent === 'function' ||
            (this.CustomEvent.toString().indexOf('CustomEventConstructor')>-1)))) {

// CustomEvent
        this.CustomEvent = function CustomEvent(type, eventInitDict) {
            if (!type) {
                throw Error('TypeError: Failed to construct "CustomEvent": An event name must be provided.');
            }

            var event;
            eventInitDict = eventInitDict || {bubbles: false, cancelable: false, detail: null};

            if ('createEvent' in document) {
                try {
                    event = document.createEvent('CustomEvent');
                    event.initCustomEvent(type, eventInitDict.bubbles, eventInitDict.cancelable, eventInitDict.detail);
                } catch (error) {
                    // for browsers which don't support CustomEvent at all, we use a regular event instead
                    event = document.createEvent('Event');
                    event.initEvent(type, eventInitDict.bubbles, eventInitDict.cancelable);
                    event.detail = eventInitDict.detail;
                }
            } else {

                // IE8
                event = new Event(type, eventInitDict);
                event.detail = eventInitDict && eventInitDict.detail || null;
            }
            return event;
        };

        CustomEvent.prototype = Event.prototype;

    }

    if (!('IntersectionObserver' in this &&
        'IntersectionObserverEntry' in this)) {

// IntersectionObserver
        /**
         * Copyright 2016 Google Inc. All Rights Reserved.
         *
         * Licensed under the Apache License, Version 2.0 (the "License");
         * you may not use this file except in compliance with the License.
         * You may obtain a copy of the License at
         *
         *     http://www.apache.org/licenses/LICENSE-2.0
         *
         * Unless required by applicable law or agreed to in writing, software
         * distributed under the License is distributed on an "AS IS" BASIS,
         * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
         * See the License for the specific language governing permissions and
         * limitations under the License.
         */

        (function(window, document) {
            'use strict';


// Exits early if all IntersectionObserver and IntersectionObserverEntry
// features are natively supported.
            if ('IntersectionObserver' in window &&
                'IntersectionObserverEntry' in window &&
                'intersectionRatio' in window.IntersectionObserverEntry.prototype) {
                return;
            }


            /**
             * An IntersectionObserver registry. This registry exists to hold a strong
             * reference to IntersectionObserver instances currently observering a target
             * element. Without this registry, instances without another reference may be
             * garbage collected.
             */
            var registry = [];


            /**
             * Creates the global IntersectionObserverEntry constructor.
             * https://wicg.github.io/IntersectionObserver/#intersection-observer-entry
             * @param {Object} entry A dictionary of instance properties.
             * @constructor
             */
            function IntersectionObserverEntry(entry) {
                this.time = entry.time;
                this.target = entry.target;
                this.rootBounds = entry.rootBounds;
                this.boundingClientRect = entry.boundingClientRect;
                this.intersectionRect = entry.intersectionRect || getEmptyRect();
                try {
                    this.isIntersecting = !!entry.intersectionRect;
                } catch (err) {
                    // This means we are using the IntersectionObserverEntry polyfill which has only defined a getter
                }

                // Calculates the intersection ratio.
                var targetRect = this.boundingClientRect;
                var targetArea = targetRect.width * targetRect.height;
                var intersectionRect = this.intersectionRect;
                var intersectionArea = intersectionRect.width * intersectionRect.height;

                // Sets intersection ratio.
                if (targetArea) {
                    this.intersectionRatio = intersectionArea / targetArea;
                } else {
                    // If area is zero and is intersecting, sets to 1, otherwise to 0
                    this.intersectionRatio = this.isIntersecting ? 1 : 0;
                }
            }


            /**
             * Creates the global IntersectionObserver constructor.
             * https://wicg.github.io/IntersectionObserver/#intersection-observer-interface
             * @param {Function} callback The function to be invoked after intersection
             *     changes have queued. The function is not invoked if the queue has
             *     been emptied by calling the `takeRecords` method.
             * @param {Object=} opt_options Optional configuration options.
             * @constructor
             */
            function IntersectionObserver(callback, opt_options) {

                var options = opt_options || {};

                if (typeof callback != 'function') {
                    throw new Error('callback must be a function');
                }

                if (options.root && options.root.nodeType != 1) {
                    throw new Error('root must be an Element');
                }

                // Binds and throttles `this._checkForIntersections`.
                this._checkForIntersections = throttle(
                    this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);

                // Private properties.
                this._callback = callback;
                this._observationTargets = [];
                this._queuedEntries = [];
                this._rootMarginValues = this._parseRootMargin(options.rootMargin);

                // Public properties.
                this.thresholds = this._initThresholds(options.threshold);
                this.root = options.root || null;
                this.rootMargin = this._rootMarginValues.map(function(margin) {
                    return margin.value + margin.unit;
                }).join(' ');
            }


            /**
             * The minimum interval within which the document will be checked for
             * intersection changes.
             */
            IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;


            /**
             * The frequency in which the polyfill polls for intersection changes.
             * this can be updated on a per instance basis and must be set prior to
             * calling `observe` on the first target.
             */
            IntersectionObserver.prototype.POLL_INTERVAL = null;


            /**
             * Starts observing a target element for intersection changes based on
             * the thresholds values.
             * @param {Element} target The DOM element to observe.
             */
            IntersectionObserver.prototype.observe = function(target) {
                // If the target is already being observed, do nothing.
                if (this._observationTargets.some(function(item) {
                    return item.element == target;
                })) {
                    return;
                }

                if (!(target && target.nodeType == 1)) {
                    throw new Error('target must be an Element');
                }

                this._registerInstance();
                this._observationTargets.push({element: target, entry: null});
                this._monitorIntersections();
            };


            /**
             * Stops observing a target element for intersection changes.
             * @param {Element} target The DOM element to observe.
             */
            IntersectionObserver.prototype.unobserve = function(target) {
                this._observationTargets =
                    this._observationTargets.filter(function(item) {

                        return item.element != target;
                    });
                if (!this._observationTargets.length) {
                    this._unmonitorIntersections();
                    this._unregisterInstance();
                }
            };


            /**
             * Stops observing all target elements for intersection changes.
             */
            IntersectionObserver.prototype.disconnect = function() {
                this._observationTargets = [];
                this._unmonitorIntersections();
                this._unregisterInstance();
            };


            /**
             * Returns any queue entries that have not yet been reported to the
             * callback and clears the queue. This can be used in conjunction with the
             * callback to obtain the absolute most up-to-date intersection information.
             * @return {Array} The currently queued entries.
             */
            IntersectionObserver.prototype.takeRecords = function() {
                var records = this._queuedEntries.slice();
                this._queuedEntries = [];
                return records;
            };


            /**
             * Accepts the threshold value from the user configuration object and
             * returns a sorted array of unique threshold values. If a value is not
             * between 0 and 1 and error is thrown.
             * @private
             * @param {Array|number=} opt_threshold An optional threshold value or
             *     a list of threshold values, defaulting to [0].
             * @return {Array} A sorted list of unique and valid threshold values.
             */
            IntersectionObserver.prototype._initThresholds = function(opt_threshold) {
                var threshold = opt_threshold || [0];
                if (!Array.isArray(threshold)) threshold = [threshold];

                return threshold.sort().filter(function(t, i, a) {
                    if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
                        throw new Error('threshold must be a number between 0 and 1 inclusively');
                    }
                    return t !== a[i - 1];
                });
            };


            /**
             * Accepts the rootMargin value from the user configuration object
             * and returns an array of the four margin values as an object containing
             * the value and unit properties. If any of the values are not properly
             * formatted or use a unit other than px or %, and error is thrown.
             * @private
             * @param {string=} opt_rootMargin An optional rootMargin value,
             *     defaulting to '0px'.
             * @return {Array<Object>} An array of margin objects with the keys
             *     value and unit.
             */
            IntersectionObserver.prototype._parseRootMargin = function(opt_rootMargin) {
                var marginString = opt_rootMargin || '0px';
                var margins = marginString.split(/\s+/).map(function(margin) {
                    var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
                    if (!parts) {
                        throw new Error('rootMargin must be specified in pixels or percent');
                    }
                    return {value: parseFloat(parts[1]), unit: parts[2]};
                });

                // Handles shorthand.
                margins[1] = margins[1] || margins[0];
                margins[2] = margins[2] || margins[0];
                margins[3] = margins[3] || margins[1];

                return margins;
            };


            /**
             * Starts polling for intersection changes if the polling is not already
             * happening, and if the page's visibilty state is visible.
             * @private
             */
            IntersectionObserver.prototype._monitorIntersections = function() {
                if (!this._monitoringIntersections) {
                    this._monitoringIntersections = true;

                    this._checkForIntersections();

                    // If a poll interval is set, use polling instead of listening to
                    // resize and scroll events or DOM mutations.
                    if (this.POLL_INTERVAL) {
                        this._monitoringInterval = setInterval(
                            this._checkForIntersections, this.POLL_INTERVAL);
                    }
                    else {
                        addEvent(window, 'resize', this._checkForIntersections, true);
                        addEvent(document, 'scroll', this._checkForIntersections, true);

                        if ('MutationObserver' in window) {
                            this._domObserver = new MutationObserver(this._checkForIntersections);
                            this._domObserver.observe(document, {
                                attributes: true,
                                childList: true,
                                characterData: true,
                                subtree: true
                            });
                        }
                    }
                }
            };


            /**
             * Stops polling for intersection changes.
             * @private
             */
            IntersectionObserver.prototype._unmonitorIntersections = function() {
                if (this._monitoringIntersections) {
                    this._monitoringIntersections = false;

                    clearInterval(this._monitoringInterval);
                    this._monitoringInterval = null;

                    removeEvent(window, 'resize', this._checkForIntersections, true);
                    removeEvent(document, 'scroll', this._checkForIntersections, true);

                    if (this._domObserver) {
                        this._domObserver.disconnect();
                        this._domObserver = null;
                    }
                }
            };


            /**
             * Scans each observation target for intersection changes and adds them
             * to the internal entries queue. If new entries are found, it
             * schedules the callback to be invoked.
             * @private
             */
            IntersectionObserver.prototype._checkForIntersections = function() {
                var rootIsInDom = this._rootIsInDom();
                var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();

                this._observationTargets.forEach(function(item) {
                    var target = item.element;
                    var targetRect = getBoundingClientRect(target);
                    var rootContainsTarget = this._rootContainsTarget(target);
                    var oldEntry = item.entry;
                    var intersectionRect = rootIsInDom && rootContainsTarget &&
                        this._computeTargetAndRootIntersection(target, rootRect);

                    var newEntry = item.entry = new IntersectionObserverEntry({
                        time: now(),
                        target: target,
                        boundingClientRect: targetRect,
                        rootBounds: rootRect,
                        intersectionRect: intersectionRect
                    });

                    if (!oldEntry) {
                        this._queuedEntries.push(newEntry);
                    } else if (rootIsInDom && rootContainsTarget) {
                        // If the new entry intersection ratio has crossed any of the
                        // thresholds, add a new entry.
                        if (this._hasCrossedThreshold(oldEntry, newEntry)) {
                            this._queuedEntries.push(newEntry);
                        }
                    } else {
                        // If the root is not in the DOM or target is not contained within
                        // root but the previous entry for this target had an intersection,
                        // add a new record indicating removal.
                        if (oldEntry && oldEntry.isIntersecting) {
                            this._queuedEntries.push(newEntry);
                        }
                    }
                }, this);

                if (this._queuedEntries.length) {
                    this._callback(this.takeRecords(), this);
                }
            };


            /**
             * Accepts a target and root rect computes the intersection between then
             * following the algorithm in the spec.
             * TODO(philipwalton): at this time clip-path is not considered.
             * https://wicg.github.io/IntersectionObserver/#calculate-intersection-rect-algo
             * @param {Element} target The target DOM element
             * @param {Object} rootRect The bounding rect of the root after being
             *     expanded by the rootMargin value.
             * @return {?Object} The final intersection rect object or undefined if no
             *     intersection is found.
             * @private
             */
            IntersectionObserver.prototype._computeTargetAndRootIntersection =
                function(target, rootRect) {

                    // If the element isn't displayed, an intersection can't happen.
                    if (window.getComputedStyle(target).display == 'none') return;

                    var targetRect = getBoundingClientRect(target);
                    var intersectionRect = targetRect;
                    var parent = getParentNode(target);
                    var atRoot = false;

                    while (!atRoot) {
                        var parentRect = null;
                        var parentComputedStyle = parent.nodeType == 1 ?
                            window.getComputedStyle(parent) : {};

                        // If the parent isn't displayed, an intersection can't happen.
                        if (parentComputedStyle.display == 'none') return;

                        if (parent == this.root || parent == document) {
                            atRoot = true;
                            parentRect = rootRect;
                        } else {
                            // If the element has a non-visible overflow, and it's not the <body>
                            // or <html> element, update the intersection rect.
                            // Note: <body> and <html> cannot be clipped to a rect that's not also
                            // the document rect, so no need to compute a new intersection.
                            if (parent != document.body &&
                                parent != document.documentElement &&
                                parentComputedStyle.overflow != 'visible') {
                                parentRect = getBoundingClientRect(parent);
                            }
                        }

                        // If either of the above conditionals set a new parentRect,
                        // calculate new intersection data.
                        if (parentRect) {
                            intersectionRect = computeRectIntersection(parentRect, intersectionRect);

                            if (!intersectionRect) break;
                        }
                        parent = getParentNode(parent);
                    }
                    return intersectionRect;
                };


            /**
             * Returns the root rect after being expanded by the rootMargin value.
             * @return {Object} The expanded root rect.
             * @private
             */
            IntersectionObserver.prototype._getRootRect = function() {
                var rootRect;
                if (this.root) {
                    rootRect = getBoundingClientRect(this.root);
                } else {
                    // Use <html>/<body> instead of window since scroll bars affect size.
                    var html = document.documentElement;
                    var body = document.body;
                    rootRect = {
                        top: 0,
                        left: 0,
                        right: html.clientWidth || body.clientWidth,
                        width: html.clientWidth || body.clientWidth,
                        bottom: html.clientHeight || body.clientHeight,
                        height: html.clientHeight || body.clientHeight
                    };
                }
                return this._expandRectByRootMargin(rootRect);
            };


            /**
             * Accepts a rect and expands it by the rootMargin value.
             * @param {Object} rect The rect object to expand.
             * @return {Object} The expanded rect.
             * @private
             */
            IntersectionObserver.prototype._expandRectByRootMargin = function(rect) {
                var margins = this._rootMarginValues.map(function(margin, i) {
                    return margin.unit == 'px' ? margin.value :
                        margin.value * (i % 2 ? rect.width : rect.height) / 100;
                });
                var newRect = {
                    top: rect.top - margins[0],
                    right: rect.right + margins[1],
                    bottom: rect.bottom + margins[2],
                    left: rect.left - margins[3]
                };
                newRect.width = newRect.right - newRect.left;
                newRect.height = newRect.bottom - newRect.top;

                return newRect;
            };


            /**
             * Accepts an old and new entry and returns true if at least one of the
             * threshold values has been crossed.
             * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
             *    particular target element or null if no previous entry exists.
             * @param {IntersectionObserverEntry} newEntry The current entry for a
             *    particular target element.
             * @return {boolean} Returns true if a any threshold has been crossed.
             * @private
             */
            IntersectionObserver.prototype._hasCrossedThreshold =
                function(oldEntry, newEntry) {

                    // To make comparing easier, an entry that has a ratio of 0
                    // but does not actually intersect is given a value of -1
                    var oldRatio = oldEntry && oldEntry.isIntersecting ?
                        oldEntry.intersectionRatio || 0 : -1;
                    var newRatio = newEntry.isIntersecting ?
                        newEntry.intersectionRatio || 0 : -1;

                    // Ignore unchanged ratios
                    if (oldRatio === newRatio) return;

                    for (var i = 0; i < this.thresholds.length; i++) {
                        var threshold = this.thresholds[i];

                        // Return true if an entry matches a threshold or if the new ratio
                        // and the old ratio are on the opposite sides of a threshold.
                        if (threshold == oldRatio || threshold == newRatio ||
                            threshold < oldRatio !== threshold < newRatio) {
                            return true;
                        }
                    }
                };


            /**
             * Returns whether or not the root element is an element and is in the DOM.
             * @return {boolean} True if the root element is an element and is in the DOM.
             * @private
             */
            IntersectionObserver.prototype._rootIsInDom = function() {
                return !this.root || containsDeep(document, this.root);
            };


            /**
             * Returns whether or not the target element is a child of root.
             * @param {Element} target The target element to check.
             * @return {boolean} True if the target element is a child of root.
             * @private
             */
            IntersectionObserver.prototype._rootContainsTarget = function(target) {
                return containsDeep(this.root || document, target);
            };


            /**
             * Adds the instance to the global IntersectionObserver registry if it isn't
             * already present.
             * @private
             */
            IntersectionObserver.prototype._registerInstance = function() {
                if (registry.indexOf(this) < 0) {
                    registry.push(this);
                }
            };


            /**
             * Removes the instance from the global IntersectionObserver registry.
             * @private
             */
            IntersectionObserver.prototype._unregisterInstance = function() {
                var index = registry.indexOf(this);
                if (index != -1) registry.splice(index, 1);
            };


            /**
             * Returns the result of the performance.now() method or null in browsers
             * that don't support the API.
             * @return {number} The elapsed time since the page was requested.
             */
            function now() {
                return window.performance && performance.now && performance.now();
            }


            /**
             * Throttles a function and delays its executiong, so it's only called at most
             * once within a given time period.
             * @param {Function} fn The function to throttle.
             * @param {number} timeout The amount of time that must pass before the
             *     function can be called again.
             * @return {Function} The throttled function.
             */
            function throttle(fn, timeout) {
                var timer = null;
                return function () {
                    if (!timer) {
                        timer = setTimeout(function() {
                            fn();
                            timer = null;
                        }, timeout);
                    }
                };
            }


            /**
             * Adds an event handler to a DOM node ensuring cross-browser compatibility.
             * @param {Node} node The DOM node to add the event handler to.
             * @param {string} event The event name.
             * @param {Function} fn The event handler to add.
             * @param {boolean} opt_useCapture Optionally adds the even to the capture
             *     phase. Note: this only works in modern browsers.
             */
            function addEvent(node, event, fn, opt_useCapture) {
                if (typeof node.addEventListener == 'function') {
                    node.addEventListener(event, fn, opt_useCapture || false);
                }
                else if (typeof node.attachEvent == 'function') {
                    node.attachEvent('on' + event, fn);
                }
            }


            /**
             * Removes a previously added event handler from a DOM node.
             * @param {Node} node The DOM node to remove the event handler from.
             * @param {string} event The event name.
             * @param {Function} fn The event handler to remove.
             * @param {boolean} opt_useCapture If the event handler was added with this
             *     flag set to true, it should be set to true here in order to remove it.
             */
            function removeEvent(node, event, fn, opt_useCapture) {
                if (typeof node.removeEventListener == 'function') {
                    node.removeEventListener(event, fn, opt_useCapture || false);
                }
                else if (typeof node.detatchEvent == 'function') {
                    node.detatchEvent('on' + event, fn);
                }
            }


            /**
             * Returns the intersection between two rect objects.
             * @param {Object} rect1 The first rect.
             * @param {Object} rect2 The second rect.
             * @return {?Object} The intersection rect or undefined if no intersection
             *     is found.
             */
            function computeRectIntersection(rect1, rect2) {
                var top = Math.max(rect1.top, rect2.top);
                var bottom = Math.min(rect1.bottom, rect2.bottom);
                var left = Math.max(rect1.left, rect2.left);
                var right = Math.min(rect1.right, rect2.right);
                var width = right - left;
                var height = bottom - top;

                return (width >= 0 && height >= 0) && {
                    top: top,
                    bottom: bottom,
                    left: left,
                    right: right,
                    width: width,
                    height: height
                };
            }


            /**
             * Shims the native getBoundingClientRect for compatibility with older IE.
             * @param {Element} el The element whose bounding rect to get.
             * @return {Object} The (possibly shimmed) rect of the element.
             */
            function getBoundingClientRect(el) {
                var rect;

                try {
                    rect = el.getBoundingClientRect();
                } catch (err) {
                    // Ignore Windows 7 IE11 "Unspecified error"
                    // https://github.com/WICG/IntersectionObserver/pull/205
                }

                if (!rect) return getEmptyRect();

                // Older IE
                if (!(rect.width && rect.height)) {
                    rect = {
                        top: rect.top,
                        right: rect.right,
                        bottom: rect.bottom,
                        left: rect.left,
                        width: rect.right - rect.left,
                        height: rect.bottom - rect.top
                    };
                }
                return rect;
            }


            /**
             * Returns an empty rect object. An empty rect is returned when an element
             * is not in the DOM.
             * @return {Object} The empty rect.
             */
            function getEmptyRect() {
                return {
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                    width: 0,
                    height: 0
                };
            }

            /**
             * Checks to see if a parent element contains a child elemnt (including inside
             * shadow DOM).
             * @param {Node} parent The parent element.
             * @param {Node} child The child element.
             * @return {boolean} True if the parent node contains the child node.
             */
            function containsDeep(parent, child) {
                var node = child;
                while (node) {
                    if (node == parent) return true;

                    node = getParentNode(node);
                }
                return false;
            }


            /**
             * Gets the parent node of an element or its host element if the parent node
             * is a shadow root.
             * @param {Node} node The node whose parent to get.
             * @return {Node|null} The parent node or null if no parent exists.
             */
            function getParentNode(node) {
                var parent = node.parentNode;

                if (parent && parent.nodeType == 11 && parent.host) {
                    // If the parent is a shadow root, return the host element.
                    return parent.host;
                }
                return parent;
            }


// Exposes the constructors globally.
            window.IntersectionObserver = IntersectionObserver;
            window.IntersectionObserverEntry = IntersectionObserverEntry;

        }(window, document));

    }

    if (!('isInteger' in Number)) {

// Number.isInteger
        Number.isInteger = Number.isInteger || function (value) {
            return typeof value === "number" &&
                isFinite(value) &&
                Math.floor(value) === value;
        };

    }

    if (!('entries' in Object)) {

// Object.entries
        Object.entries = function entries(object) {
            var keys = Object.keys(object);

            return keys
                .reduce(function(entries, key) {
                    var entry = typeof key === 'string' && object.propertyIsEnumerable(key) ? [
                        [key, object[key]]
                    ] : [];
                    return entries.concat(entry);
                }, []);
        };

    }

    if (!('values' in Object)) {

// Object.values
        (function () {
            Object.defineProperty(Object, 'values', {
                configurable: true,
                enumerable: false,
                value: function (object) {
                    return Object.keys(object).map(function (key) {
                        return object[key];
                    });
                },
                writable: true
            });
        }());

    }

    if (!('Symbol' in this && 'species' in this.Symbol)) {

// Symbol.species
        Object.defineProperty(Symbol, 'species', {value: Symbol('species')});

    }

    if (!('Set' in this && (function() {
        return (new Set([1,2])).size === 2;
    }()))) {

// Set
        (function(global) {


            // Deleted map items mess with iterator pointers, so rather than removing them mark them as deleted. Can't use undefined or null since those both valid keys so use a private symbol.
            var undefMarker = Symbol('undef');

            // NaN cannot be found in an array using indexOf, so we encode NaNs using a private symbol.
            var NaNMarker = Symbol('NaN');

            function encodeVal(data) {
                return Number.isNaN(data) ? NaNMarker : data;
            }
            function decodeVal(encodedData) {
                return (encodedData === NaNMarker) ? NaN : encodedData;
            }

            function makeIterator(setInst, getter) {
                var nextIdx = 0;
                return {
                    next: function() {
                        while (setInst._values[nextIdx] === undefMarker) nextIdx++;
                        if (nextIdx === setInst._values.length) {
                            return {value: void 0, done: true};
                        }
                        else {
                            return {value: getter.call(setInst, nextIdx++), done: false};
                        }
                    }
                };
            }

            var Set = function Set() {
                var data = arguments[0];
                this._values = [];
                this.size = this._size = 0;

                // If `data` is iterable (indicated by presence of a forEach method), pre-populate the set
                data && (typeof data.forEach === 'function') && data.forEach(function (item) {
                    this.add.call(this, item);
                }, this);
            };

            // Some old engines do not support ES5 getters/setters.  Since Set only requires these for the size property, we can fall back to setting the size property statically each time the size of the set changes.
            try {
                Object.defineProperty(Set.prototype, 'size', {
                    get: function() {
                        return this._size;
                    }
                });
            } catch(e) {
            }

            Set.prototype['add'] = function(value) {
                value = encodeVal(value);
                if (this._values.indexOf(value) === -1) {
                    this._values.push(value);
                    this.size = ++this._size;
                }
                return this;
            };
            Set.prototype['has'] = function(value) {
                return (this._values.indexOf(encodeVal(value)) !== -1);
            };
            Set.prototype['delete'] = function(value) {
                var idx = this._values.indexOf(encodeVal(value));
                if (idx === -1) return false;
                this._values[idx] = undefMarker;
                this.size = --this._size;
                return true;
            };
            Set.prototype['clear'] = function() {
                this._values = [];
                this.size = this._size = 0;
            };
            Set.prototype[Symbol.iterator] =
                Set.prototype['values'] =
                    Set.prototype['keys'] = function() {
                        var iterator = makeIterator(this, function(i) { return decodeVal(this._values[i]); });
                        iterator[Symbol.iterator] = this.keys.bind(this);
                        return iterator;
                    };
            Set.prototype['entries'] = function() {
                var iterator = makeIterator(this, function(i) { return [decodeVal(this._values[i]), decodeVal(this._values[i])]; });
                iterator[Symbol.iterator] = this.entries.bind(this);
                return iterator;
            };
            Set.prototype['forEach'] = function(callbackFn, thisArg) {
                thisArg = thisArg || global;
                var iterator = this.entries();
                var result = iterator.next();
                while (result.done === false) {
                    callbackFn.call(thisArg, result.value[1], result.value[0], this);
                    result = iterator.next();
                }
            };
            Set.prototype['constructor'] =
                Set.prototype[Symbol.species] = Set;

            Set.prototype.constructor = Set;
            Set.name = "Set";

            // Export the object
            global.Set = Set;

        }(this));

    }

    if (!('startsWith' in String.prototype)) {

// String.prototype.startsWith
        String.prototype.startsWith = function (string) {
            var index = arguments.length < 2 ? 0 : arguments[1];

            return this.slice(index).indexOf(string) === 0;
        };

    }

    if (!('Promise' in this)) {

// Promise
        !function(n){function t(e){if(r[e])return r[e].exports;var o=r[e]={exports:{},id:e,loaded:!1};return n[e].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var r={};return t.m=n,t.c=r,t.p="",t(0)}({0:/*!***********************!*\
  !*** ./src/global.js ***!
  \***********************/
                function(n,t,r){(function(n){var t=r(/*! ./yaku */80);try{(n||{}).Promise=t,window.Promise=t}catch(err){}}).call(t,function(){return this}())},80:/*!*********************!*\
  !*** ./src/yaku.js ***!
  \*********************/
                function(n,t){(function(t){!function(){"use strict";function r(){return un[B][G]||J}function e(n,t){for(var r in t)n[r]=t[r]}function o(n){return n&&"object"==typeof n}function i(n){return"function"==typeof n}function u(n,t){return n instanceof t}function c(n){return u(n,U)}function f(n,t,r){if(!t(n))throw v(r)}function s(){try{return C.apply(F,arguments)}catch(e){return rn.e=e,rn}}function a(n,t){return C=n,F=t,s}function l(n,t){function r(){for(var r=0;r<o;)t(e[r],e[r+1]),e[r++]=S,e[r++]=S;o=0,e.length>n&&(e.length=n)}var e=O(n),o=0;return function(n,t){e[o++]=n,e[o++]=t,2===o&&un.nextTick(r)}}function h(n,t){var r,e,o,c,f=0;if(!n)throw v(W);var s=n[un[B][D]];if(i(s))e=s.call(n);else{if(!i(n.next)){if(u(n,O)){for(r=n.length;f<r;)t(n[f],f++);return f}throw v(W)}e=n}for(;!(o=e.next()).done;)if(c=a(t)(o.value,f++),c===rn)throw i(e[K])&&e[K](),c.e;return f}function v(n){return new TypeError(n)}function _(n){return(n?"":X)+(new U).stack}function d(n,t){var r="on"+n.toLowerCase(),e=H[r];I&&I.listeners(n).length?n===tn?I.emit(n,t._v,t):I.emit(n,t):e?e({reason:t._v,promise:t}):un[n](t._v,t)}function p(n){return n&&n._s}function w(n){if(p(n))return new n(en);var t,r,e;return t=new n(function(n,o){if(t)throw v();r=n,e=o}),f(r,i),f(e,i),t}function m(n,t){return function(r){A&&(n[Q]=_(!0)),t===q?T(n,r):k(n,t,r)}}function y(n,t,r,e){return i(r)&&(t._onFulfilled=r),i(e)&&(n[M]&&d(nn,n),t._onRejected=e),A&&(t._p=n),n[n._c++]=t,n._s!==z&&cn(n,t),t}function j(n){if(n._umark)return!0;n._umark=!0;for(var t,r=0,e=n._c;r<e;)if(t=n[r++],t._onRejected||j(t))return!0}function x(n,t){function r(n){return e.push(n.replace(/^\s+|\s+$/g,""))}var e=[];return A&&(t[Q]&&r(t[Q]),function o(n){n&&N in n&&(o(n._next),r(n[N]+""),o(n._p))}(t)),(n&&n.stack?n.stack:n)+("\n"+e.join("\n")).replace(on,"")}function g(n,t){return n(t)}function k(n,t,r){var e=0,o=n._c;if(n._s===z)for(n._s=t,n._v=r,t===$&&(A&&c(r)&&(r.longStack=x(r,n)),fn(n));e<o;)cn(n,n[e++]);return n}function T(n,t){if(t===n&&t)return k(n,$,v(Y)),n;if(t!==P&&(i(t)||o(t))){var r=a(b)(t);if(r===rn)return k(n,$,r.e),n;i(r)?(A&&p(t)&&(n._next=t),p(t)?R(n,t,r):un.nextTick(function(){R(n,t,r)})):k(n,q,t)}else k(n,q,t);return n}function b(n){return n.then}function R(n,t,r){var e=a(r,t)(function(r){t&&(t=P,T(n,r))},function(r){t&&(t=P,k(n,$,r))});e===rn&&t&&(k(n,$,e.e),t=P)}var S,C,F,P=null,E="object"==typeof window,H=E?window:t,I=H.process,L=H.console,A=!1,O=Array,U=Error,$=1,q=2,z=3,B="Symbol",D="iterator",G="species",J=B+"("+G+")",K="return",M="_uh",N="_pt",Q="_st",V="Invalid this",W="Invalid argument",X="\nFrom previous ",Y="Chaining cycle detected for promise",Z="Uncaught (in promise)",nn="rejectionHandled",tn="unhandledRejection",rn={e:P},en=function(){},on=/^.+\/node_modules\/yaku\/.+\n?/gm,un=n.exports=function(n){var t,r=this;if(!o(r)||r._s!==S)throw v(V);if(r._s=z,A&&(r[N]=_()),n!==en){if(!i(n))throw v(W);t=a(n)(m(r,q),m(r,$)),t===rn&&k(r,$,t.e)}};un["default"]=un,e(un.prototype,{then:function(n,t){if(void 0===this._s)throw v();return y(this,w(un.speciesConstructor(this,un)),n,t)},"catch":function(n){return this.then(S,n)},"finally":function(n){function t(t){return un.resolve(n()).then(function(){return t})}return this.then(t,t)},_c:0,_p:P}),un.resolve=function(n){return p(n)?n:T(w(this),n)},un.reject=function(n){return k(w(this),$,n)},un.race=function(n){var t=this,r=w(t),e=function(n){k(r,q,n)},o=function(n){k(r,$,n)},i=a(h)(n,function(n){t.resolve(n).then(e,o)});return i===rn?t.reject(i.e):r},un.all=function(n){function t(n){k(o,$,n)}var r,e=this,o=w(e),i=[];return r=a(h)(n,function(n,u){e.resolve(n).then(function(n){i[u]=n,--r||k(o,q,i)},t)}),r===rn?e.reject(r.e):(r||k(o,q,[]),o)},un.Symbol=H[B]||{},a(function(){Object.defineProperty(un,r(),{get:function(){return this}})})(),un.speciesConstructor=function(n,t){var e=n.constructor;return e?e[r()]||t:t},un.unhandledRejection=function(n,t){L&&L.error(Z,A?t.longStack:x(n,t))},un.rejectionHandled=en,un.enableLongStackTrace=function(){A=!0},un.nextTick=E?function(n){setTimeout(n)}:I.nextTick,un._s=1;var cn=l(999,function(n,t){var r,e;return e=n._s!==$?t._onFulfilled:t._onRejected,e===S?void k(t,n._s,n._v):(r=a(g)(e,n._v),r===rn?void k(t,$,r.e):void T(t,r))}),fn=l(9,function(n){j(n)||(n[M]=1,d(tn,n))})}()}).call(t,function(){return this}())}});
    }

    if (!('fetch' in this)) {

// fetch
        (function(self) {
            'use strict';

            var support = {
                searchParams: 'URLSearchParams' in self,
                iterable: 'Symbol' in self && 'iterator' in Symbol,
                blob: 'FileReader' in self && 'Blob' in self && (function() {
                    try {
                        new Blob()
                        return true
                    } catch(e) {
                        return false
                    }
                })(),
                formData: 'FormData' in self,
                arrayBuffer: 'ArrayBuffer' in self
            }

            if (support.arrayBuffer) {
                var viewClasses = [
                    '[object Int8Array]',
                    '[object Uint8Array]',
                    '[object Uint8ClampedArray]',
                    '[object Int16Array]',
                    '[object Uint16Array]',
                    '[object Int32Array]',
                    '[object Uint32Array]',
                    '[object Float32Array]',
                    '[object Float64Array]'
                ]

                var isDataView = function(obj) {
                    return obj && DataView.prototype.isPrototypeOf(obj)
                }

                var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                    return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
                }
            }

            function normalizeName(name) {
                if (typeof name !== 'string') {
                    name = String(name)
                }
                if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
                    throw new TypeError('Invalid character in header field name')
                }
                return name.toLowerCase()
            }

            function normalizeValue(value) {
                if (typeof value !== 'string') {
                    value = String(value)
                }
                return value
            }

            // Build a destructive iterator for the value list
            function iteratorFor(items) {
                var iterator = {
                    next: function() {
                        var value = items.shift()
                        return {done: value === undefined, value: value}
                    }
                }

                if (support.iterable) {
                    iterator[Symbol.iterator] = function() {
                        return iterator
                    }
                }

                return iterator
            }

            function Headers(headers) {
                this.map = {}

                if (headers instanceof Headers) {
                    headers.forEach(function(value, name) {
                        this.append(name, value)
                    }, this)
                } else if (Array.isArray(headers)) {
                    headers.forEach(function(header) {
                        this.append(header[0], header[1])
                    }, this)
                } else if (headers) {
                    Object.getOwnPropertyNames(headers).forEach(function(name) {
                        this.append(name, headers[name])
                    }, this)
                }
            }

            Headers.prototype.append = function(name, value) {
                name = normalizeName(name)
                value = normalizeValue(value)
                var oldValue = this.map[name]
                this.map[name] = oldValue ? oldValue+','+value : value
            }

            Headers.prototype['delete'] = function(name) {
                delete this.map[normalizeName(name)]
            }

            Headers.prototype.get = function(name) {
                name = normalizeName(name)
                return this.has(name) ? this.map[name] : null
            }

            Headers.prototype.has = function(name) {
                return this.map.hasOwnProperty(normalizeName(name))
            }

            Headers.prototype.set = function(name, value) {
                this.map[normalizeName(name)] = normalizeValue(value)
            }

            Headers.prototype.forEach = function(callback, thisArg) {
                for (var name in this.map) {
                    if (this.map.hasOwnProperty(name)) {
                        callback.call(thisArg, this.map[name], name, this)
                    }
                }
            }

            Headers.prototype.keys = function() {
                var items = []
                this.forEach(function(value, name) { items.push(name) })
                return iteratorFor(items)
            }

            Headers.prototype.values = function() {
                var items = []
                this.forEach(function(value) { items.push(value) })
                return iteratorFor(items)
            }

            Headers.prototype.entries = function() {
                var items = []
                this.forEach(function(value, name) { items.push([name, value]) })
                return iteratorFor(items)
            }

            if (support.iterable) {
                Headers.prototype[Symbol.iterator] = Headers.prototype.entries
            }

            function consumed(body) {
                if (body.bodyUsed) {
                    return Promise.reject(new TypeError('Already read'))
                }
                body.bodyUsed = true
            }

            function fileReaderReady(reader) {
                return new Promise(function(resolve, reject) {
                    reader.onload = function() {
                        resolve(reader.result)
                    }
                    reader.onerror = function() {
                        reject(reader.error)
                    }
                })
            }

            function readBlobAsArrayBuffer(blob) {
                var reader = new FileReader()
                var promise = fileReaderReady(reader)
                reader.readAsArrayBuffer(blob)
                return promise
            }

            function readBlobAsText(blob) {
                var reader = new FileReader()
                var promise = fileReaderReady(reader)
                reader.readAsText(blob)
                return promise
            }

            function readArrayBufferAsText(buf) {
                var view = new Uint8Array(buf)
                var chars = new Array(view.length)

                for (var i = 0; i < view.length; i++) {
                    chars[i] = String.fromCharCode(view[i])
                }
                return chars.join('')
            }

            function bufferClone(buf) {
                if (buf.slice) {
                    return buf.slice(0)
                } else {
                    var view = new Uint8Array(buf.byteLength)
                    view.set(new Uint8Array(buf))
                    return view.buffer
                }
            }

            function Body() {
                this.bodyUsed = false

                this._initBody = function(body) {
                    this._bodyInit = body
                    if (!body) {
                        this._bodyText = ''
                    } else if (typeof body === 'string') {
                        this._bodyText = body
                    } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
                        this._bodyBlob = body
                    } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
                        this._bodyFormData = body
                    } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
                        this._bodyText = body.toString()
                    } else if (support.arrayBuffer && support.blob && isDataView(body)) {
                        this._bodyArrayBuffer = bufferClone(body.buffer)
                        // IE 10-11 can't handle a DataView body.
                        this._bodyInit = new Blob([this._bodyArrayBuffer])
                    } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
                        this._bodyArrayBuffer = bufferClone(body)
                    } else {
                        throw new Error('unsupported BodyInit type')
                    }

                    if (!this.headers.get('content-type')) {
                        if (typeof body === 'string') {
                            this.headers.set('content-type', 'text/plain;charset=UTF-8')
                        } else if (this._bodyBlob && this._bodyBlob.type) {
                            this.headers.set('content-type', this._bodyBlob.type)
                        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
                            this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
                        }
                    }
                }

                if (support.blob) {
                    this.blob = function() {
                        var rejected = consumed(this)
                        if (rejected) {
                            return rejected
                        }

                        if (this._bodyBlob) {
                            return Promise.resolve(this._bodyBlob)
                        } else if (this._bodyArrayBuffer) {
                            return Promise.resolve(new Blob([this._bodyArrayBuffer]))
                        } else if (this._bodyFormData) {
                            throw new Error('could not read FormData body as blob')
                        } else {
                            return Promise.resolve(new Blob([this._bodyText]))
                        }
                    }

                    this.arrayBuffer = function() {
                        if (this._bodyArrayBuffer) {
                            return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
                        } else {
                            return this.blob().then(readBlobAsArrayBuffer)
                        }
                    }
                }

                this.text = function() {
                    var rejected = consumed(this)
                    if (rejected) {
                        return rejected
                    }

                    if (this._bodyBlob) {
                        return readBlobAsText(this._bodyBlob)
                    } else if (this._bodyArrayBuffer) {
                        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
                    } else if (this._bodyFormData) {
                        throw new Error('could not read FormData body as text')
                    } else {
                        return Promise.resolve(this._bodyText)
                    }
                }

                if (support.formData) {
                    this.formData = function() {
                        return this.text().then(decode)
                    }
                }

                this.json = function() {
                    return this.text().then(JSON.parse)
                }

                return this
            }

            // HTTP methods whose capitalization should be normalized
            var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

            function normalizeMethod(method) {
                var upcased = method.toUpperCase()
                return (methods.indexOf(upcased) > -1) ? upcased : method
            }

            function Request(input, options) {
                options = options || {}
                var body = options.body

                if (input instanceof Request) {
                    if (input.bodyUsed) {
                        throw new TypeError('Already read')
                    }
                    this.url = input.url
                    this.credentials = input.credentials
                    if (!options.headers) {
                        this.headers = new Headers(input.headers)
                    }
                    this.method = input.method
                    this.mode = input.mode
                    if (!body && input._bodyInit != null) {
                        body = input._bodyInit
                        input.bodyUsed = true
                    }
                } else {
                    this.url = String(input)
                }

                this.credentials = options.credentials || this.credentials || 'omit'
                if (options.headers || !this.headers) {
                    this.headers = new Headers(options.headers)
                }
                this.method = normalizeMethod(options.method || this.method || 'GET')
                this.mode = options.mode || this.mode || null
                this.referrer = null

                if ((this.method === 'GET' || this.method === 'HEAD') && body) {
                    throw new TypeError('Body not allowed for GET or HEAD requests')
                }
                this._initBody(body)
            }

            Request.prototype.clone = function() {
                return new Request(this, { body: this._bodyInit })
            }

            function decode(body) {
                var form = new FormData()
                body.trim().split('&').forEach(function(bytes) {
                    if (bytes) {
                        var split = bytes.split('=')
                        var name = split.shift().replace(/\+/g, ' ')
                        var value = split.join('=').replace(/\+/g, ' ')
                        form.append(decodeURIComponent(name), decodeURIComponent(value))
                    }
                })
                return form
            }

            function parseHeaders(rawHeaders) {
                var headers = new Headers()
                rawHeaders.split(/\r?\n/).forEach(function(line) {
                    var parts = line.split(':')
                    var key = parts.shift().trim()
                    if (key) {
                        var value = parts.join(':').trim()
                        headers.append(key, value)
                    }
                })
                return headers
            }

            Body.call(Request.prototype)

            function Response(bodyInit, options) {
                if (!options) {
                    options = {}
                }

                this.type = 'default'
                this.status = 'status' in options ? options.status : 200
                this.ok = this.status >= 200 && this.status < 300
                this.statusText = 'statusText' in options ? options.statusText : 'OK'
                this.headers = new Headers(options.headers)
                this.url = options.url || ''
                this._initBody(bodyInit)
            }

            Body.call(Response.prototype)

            Response.prototype.clone = function() {
                return new Response(this._bodyInit, {
                    status: this.status,
                    statusText: this.statusText,
                    headers: new Headers(this.headers),
                    url: this.url
                })
            }

            Response.error = function() {
                var response = new Response(null, {status: 0, statusText: ''})
                response.type = 'error'
                return response
            }

            var redirectStatuses = [301, 302, 303, 307, 308]

            Response.redirect = function(url, status) {
                if (redirectStatuses.indexOf(status) === -1) {
                    throw new RangeError('Invalid status code')
                }

                return new Response(null, {status: status, headers: {location: url}})
            }

            self.Headers = Headers
            self.Request = Request
            self.Response = Response

            self.fetch = function(input, init) {
                return new Promise(function(resolve, reject) {
                    var request = new Request(input, init)
                    var xhr = new XMLHttpRequest()

                    xhr.onload = function() {
                        var options = {
                            status: xhr.status,
                            statusText: xhr.statusText,
                            headers: parseHeaders(xhr.getAllResponseHeaders() || '')
                        }
                        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
                        var body = 'response' in xhr ? xhr.response : xhr.responseText
                        resolve(new Response(body, options))
                    }

                    xhr.onerror = function() {
                        reject(new TypeError('Network request failed'))
                    }

                    xhr.ontimeout = function() {
                        reject(new TypeError('Network request failed'))
                    }

                    xhr.open(request.method, request.url, true)

                    if (request.credentials === 'include') {
                        xhr.withCredentials = true
                    }

                    if ('responseType' in xhr && support.blob) {
                        xhr.responseType = 'blob'
                    }

                    request.headers.forEach(function(value, name) {
                        xhr.setRequestHeader(name, value)
                    })

                    xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
                })
            }
            self.fetch.polyfill = true
        })(typeof self !== 'undefined' ? self : this);

    }

})
    .call('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof global && global || {});
